import { Injectable } from "@angular/core";
import { Store } from "@ngrx/store";
import { AuthenticationService } from "src/app/auth/services/authentication.service";
import * as routeSelectors from "src/app/state/route/route.selector";
import { Auth } from "../primitives/auth";
import { authActions } from "src/app/state/auth/auth.actions";

@Injectable({ providedIn: "root" })
export class AuthGuard {
  currentUrl: string;

  constructor(
    private store: Store,
    private authenticationService: AuthenticationService,
  ) {
    this.store.select(routeSelectors.selectUrl).subscribe((route) => {
      this.currentUrl = route;
    });
  }


  canActivate() {
    const isCurrentUserAuthenticated = this.authenticationService.isAuthenticated();

    if (isCurrentUserAuthenticated) {
      return true;
    }
    this.store.dispatch(
      authActions.attemptUnauthenticatedNavigation({
        route: this.currentUrl,
      }),
    );
    return false;
  }
}
